// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5a805b64","186":"9b06ca50","225":"8b5a3498","272":"4177f58d","372":"0577ee6f","377":"6403ce8e","573":"d36f0c87","738":"549f7a98","841":"ee5c1410","856":"3e9cef92"}[chunkId] + ".chunk.js";
};